import qs from 'query-string';
import {
  API_ENDPOINT,
  type ClientApiV1CourseCertificatesDetailQueryString,
  useClientApiV1CourseCertificatesDetailQuery,
} from '../../resources/@types/courseSchema';

export function useClientApiCourseCertificatesDetailQuery({
  query,
  options,
}: {
  query: ClientApiV1CourseCertificatesDetailQueryString;
  options?: Parameters<typeof useClientApiV1CourseCertificatesDetailQuery>[0]['options'];
}) {
  return useClientApiV1CourseCertificatesDetailQuery({
    url: qs.stringifyUrl(
      {
        url: API_ENDPOINT.CLIENT_V1_COURSE_CERTIFICATES_DETAIL,
        query: {
          ...query,
        },
      },
      {
        skipEmptyString: true,
      },
    ),
    queryKey: getUseClientApiCourseCertificatesDetailQueryKey(query),
    options,
  });
}

const getUseClientApiCourseCertificatesDetailQueryKey = (
  query: ClientApiV1CourseCertificatesDetailQueryString,
) => [API_ENDPOINT.CLIENT_V1_COURSE_CERTIFICATES_DETAIL, query] as const;
